import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { transactionClientActions } from "../../../store/actions/transactions/transactionClient.actions";
import { useEffect, useState } from "react";
import { defaultTransactionClientModel } from "../../../models/defualt/defaultTransactionClient.model";
import { inputElementModel } from "../../../models/common/inputElement.model";
import InputElementComponent from "../../common/InputElementComponent";

import { selectElementModel } from "../../../models/common/selectElement.model";
import SelectElementComponent from "../../common/SelectElementComponent";
import { buttonElementModel } from "../../../models/common/buttonElement.model";
import ButtonElementComponent from "../../common/ButtonElementComponent";
import validationHelper from "../../../utils/helpers/validation.helper";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import LoaderComponent from "../../LoaderComponent";
import alertService from "../../../services/alert/alert.service";
import queryParamsHelper from "../../../utils/helpers/queryParams.helper";

export const PersonalDetailsStepComponent = ({ transactionClientActions, handleNext, handleBack, handleReset }) => {
  const navigate = useNavigate();
  const { companyId, chargePointId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const clientId = queryParamsHelper.get(searchParams, 'clientId');
  const stepFromQuery = queryParamsHelper.get(searchParams, 'step', '0');
  const currentStep = parseInt(stepFromQuery, 10) || 0;

  const [transactionClient, setTransactionClient] = useState({ ...defaultTransactionClientModel });
  const [errors, setErrors] = useState({});
  const [phonePrefixList, setPhonePrefixList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [registeredClient, setRegisteredClient] = useState(false);

  useEffect(() => {
    // Only reset if we're on step 1 (personal details) AND clientId exists on mount
    // This means user navigated back from a later step, so we should reset
    // We check currentStep === 1 to ensure we only reset when actually on this step
    // Running only on mount prevents removing clientId when it's just been set
    if (clientId && currentStep === 1) {
      handleReset();
      // Remove clientId from query params to reset the flow
      const newParams = queryParamsHelper.remove(searchParams, 'clientId');
      setSearchParams(newParams, { replace: true });
    }

    getAndSetPhonePrefix();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount - don't react to clientId or step changes to avoid removing it after setting

  const getAndSetPhonePrefix = async () => {
    try {
      setIsLoading(true);
      const phonePrefixResponse = await fetch("/data/PhonePrefix.json");
      if (!phonePrefixResponse.ok) throw new Error("Network response was not ok");
      const options = await phonePrefixResponse.json();
      setPhonePrefixList(options);
      setIsLoading(false);
    } catch (error) {
      handleBack();
      setIsLoading(false);
    }
  };

  const toggleRegisteredClient = () => {
    setRegisteredClient(!registeredClient);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setTransactionClient((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!validationHelper.validateIsraelMobilePhone(`${transactionClient.phonePrefix}${transactionClient.phoneNumber}`)) newErrors.phoneNumber = "יש להזין מספר נייד תקין";
    if (!transactionClient.phonePrefix) newErrors.phonePrefix = "קידומת טלפון היא שדה חובה";
    if (!transactionClient.phoneNumber) newErrors.phoneNumber = "מספר נייד הוא שדה חובה";

    if (!registeredClient) {
      if (!transactionClient.firstName) newErrors.firstName = "שם פרטי הוא שדה חובה";
      if (!transactionClient.lastName) newErrors.lastName = "שם משפחה הוא שדה חובה";
      if (!transactionClient.email) newErrors.email = "דואר אלקטרוני הוא שדה חובה";
      if (!validationHelper.valudateEmailAddress(transactionClient.email)) newErrors.email = 'יש להזין כתובת דוא"ל תקינה';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (validate()) {
      if (registeredClient) {
        await handleSubmitValidateRegisteredClient();
      } else {
        await handleSubmitAddNewClient();
      }
    }
  };

  const handleSubmitAddNewClient = async () => {
    setIsLoading(true);
    const request = { ...transactionClient, phone: `${transactionClient.phonePrefix}-${transactionClient.phoneNumber}` };
    const response = await transactionClientActions.addTransactionClient(companyId, request);
    
    // Fix: Check if response is invalid OR payload is missing
    if (!validationHelper.validateHttpResponse(response) || !response.payload) {
      alertService.error("משתמש רשום למערכת!", 'משתמש עם דוא"ל/מספר נייד שהוכנסו כבר קיים במערכת');
      setIsLoading(false);
      return;
    }
    
    // Set both clientId and step in a single operation to avoid race condition
    const stepFromQuery = queryParamsHelper.get(searchParams, 'step', '0');
    const currentStep = parseInt(stepFromQuery, 10) || 0;
    const newParams = queryParamsHelper.setMultiple(searchParams, {
      'clientId': response.payload,
      'step': (currentStep + 1).toString()
    });
    setSearchParams(newParams, { replace: true });
    setIsLoading(false);
  };

  const handleSubmitValidateRegisteredClient = async () => {
    setIsLoading(true);
    const phoneNumber = `${transactionClient.phonePrefix}-${transactionClient.phoneNumber}`;
    const response = await transactionClientActions.getIdAndValidateByPhoneNumber(companyId, phoneNumber);
    
    // Fix: Check if response is invalid OR payload is missing
    if (!validationHelper.validateHttpResponse(response) || !response.payload) {
      alertService.error("לא נמצא משתמש עם מספר הנייד שהוזן");
      setIsLoading(false);
      return;
    }
    
    // Set both clientId and step in a single operation to avoid race condition
    const stepFromQuery = queryParamsHelper.get(searchParams, 'step', '0');
    const currentStep = parseInt(stepFromQuery, 10) || 0;
    const newParams = queryParamsHelper.setMultiple(searchParams, {
      'clientId': response.payload,
      'step': (currentStep + 1).toString()
    });
    setSearchParams(newParams, { replace: true });
    setIsLoading(false);
  };

  // *********** Get Element Functions ***********
  const getRegisterLoginClientInputElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: `${registeredClient ? "משתמש חדש?" : "משתמש רשום?"} לחץ כאן`,
      onClick: toggleRegisteredClient,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  const getFirstNameInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      name: "firstName",
      value: transactionClient.firstName,
      onChange: handleInputChange,
      label: "שם פרטי",
      placeholder: "שם פרטי",
      required: true,
      error: errors.firstName,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getLastNameInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      name: "lastName",
      value: transactionClient.lastName,
      onChange: handleInputChange,
      label: "שם משפחה",
      placeholder: "שם משפחה",
      required: true,
      error: errors.lastName,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getEmailInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      type: "email",
      name: "email",
      value: transactionClient.email,
      onChange: handleInputChange,
      label: "דואר אלקטרוני",
      placeholder: "דואר אלקטרוני",
      required: true,
      error: errors.email,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getPhoneInputsElements = () => {
    return (
      <div className="flexRow alignEnd gap10">
        {getPhoneNumberInputElement()}
        {getPhonePrefixSelectElement()}
      </div>
    );
  };

  const getPhonePrefixSelectElement = () => {
    const selectElementProps = {
      ...selectElementModel,
      name: "phonePrefix",
      value: transactionClient.phonePrefix,
      onChange: handleInputChange,
      options: phonePrefixList,
    };
    return <SelectElementComponent selectElementProps={selectElementProps} />;
  };

  const getPhoneNumberInputElement = () => {
    const inputElementProps = {
      ...inputElementModel,
      type: "tel",
      name: "phoneNumber",
      value: transactionClient.phoneNumber,
      onChange: handleInputChange,
      placeholder: "מספר נייד",
      label: "מספר נייד",
      required: true,
      error: errors.phoneNumber,
    };

    return <InputElementComponent inputElementProps={inputElementProps} />;
  };

  const getGoBackButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "חזור",
      onClick: handleBack,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  const getSubmitButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "שמור והמשך",
      onClick: handleSubmit,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };
  // *********** *********** *********** ***********

  if (isLoading) return <LoaderComponent />;

  return (
    <div className="flexColumn gap10">
      {getRegisterLoginClientInputElement()}
      {!registeredClient && getFirstNameInputElement()}
      {!registeredClient && getLastNameInputElement()}
      {!registeredClient && getEmailInputElement()}
      {getPhoneInputsElements()}

      <div className="flexColumn gap10">
        {getSubmitButtonElement()}
        {getGoBackButtonElement()}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  transactionClientReducer: state.transactionClientReducer,
  transactionClientReducer: state.transactionClientReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    transactionClientActions: bindActionCreators(transactionClientActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetailsStepComponent);
